import axios from 'axios'

export const buyer = {
  namespaced: true,
  state: () => ({
    detail: {},
  }),

  mutations: {
    setDetail(state, detail) {
      state.detail = detail
    }
  },

  actions: {
    async create({ commit }, payload) {
      await axios
        .post(`/buyers/`, payload)
        .then(res => {
          commit('setDetail', res.data)
        })
        .catch(res => {
          if (typeof window !== 'undefined') {
            if (typeof CustomEvent === 'function') {
              var event = new CustomEvent('showError', {
                detail: {
                  textI18N: 'error.title',
                  error: res
                }
              })
              window.dispatchEvent(event)
            }
          }
        })
    }
  }
}
